<template>
    <div class="header">
        <slot name="title">
            <div class="header-title">
                {{title}}
            </div>
        </slot>
        <slot name="breadcrumb">
            <div class="header-breadcrumb" v-show="breadCrumb&&breadCrumb.length>0">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item class="link" v-for="(item,index) in breadCrumb" :key="index" :to="item.to">
                        {{item.label}}
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "PageHeader",
        props: ["title", "breadCrumb"]
    }
</script>

<style scoped lang="scss">
    .header {
        width: 100%;
        padding: 20px 30px 10px;
        box-sizing: border-box;
        font-size: 20px;
        color: #333;
        font-weight: normal;

        .header-title {
            position: relative;
        }

        .header-breadcrumb {
            margin: 10px 0 10px;
            box-sizing: border-box;

            .el-breadcrumb {
                font-size: 20px;
            }
        }
    }
</style>